// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + chunkId + ".bolt.css?v=" + __webpack_require__.h() + "";
};